import React, { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./Booking.css"; // Custom styling for TTD-like design

const RoomBooking = () => {
  const [date, setDate] = useState(new Date());
  const [selectedRoom, setSelectedRoom] = useState(null);
  const rooms = [
    { id: 1, name: "Room 1", rate: 100, available: true },
    { id: 2, name: "Room 2", rate: 120, available: false },
    { id: 3, name: "Room 3", rate: 80, available: true },
  ];

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    // Fetch availability based on the selected date if needed
  };

  return (
    <div className="room-booking-container">
      <h1>Room Booking</h1>
      <div className="calendar-container">
        <Calendar
          onChange={handleDateChange}
          value={date}
          className="custom-calendar" // Custom TTD-like calendar style
          showDoubleView={true} // Display two months side by side
          selectRange={true} // Allows selecting a date range
        />
      </div>

      <div className="rooms-list">
        <h2>Select a Room</h2>
        <ul>
          {rooms.map((room) => (
            <li
              key={room.id}
              className={`room-item ${room.available ? "available" : "unavailable"}`}
              onClick={() => setSelectedRoom(room)}
            >
              <span>{room.name}</span>
              <span>{`Rate: $${room.rate}`}</span>
              <span>{room.available ? "Available" : "Unavailable"}</span>
            </li>
          ))}
        </ul>
      </div>

      {selectedRoom && (
        <div className="booking-summary">
          <h3>Booking Summary</h3>
          <p>Room: {selectedRoom.name}</p>
          <p>Rate: ${selectedRoom.rate}</p>
          <p>Date: {date.toDateString()}</p>
          {/* Add further booking functionality here */}
        </div>
      )}
    </div>
  );
};

export default RoomBooking;

// import React, { useEffect, useState, useRef } from "react";
// import moment from "moment";
// import { useNavigate } from "react-router-dom";
// import Navbar from "./Navbar";
// import Header from "./Header";
// import Calendar from "react-calendar";
// import "react-calendar/dist/Calendar.css";
// import "./Accomodation.css";
// import "./Booking.css";

// const Accomodation = () => {
//   const navigate = useNavigate();
//   const userRole = localStorage.getItem("userRole");
//   const [selectedRooms, setSelectedRooms] = useState([]);
//   const [startDate, setStartDate] = useState(new Date());
//   const [nextDates, setNextDates] = useState([
//     new Date(),
//     new Date(new Date().setDate(new Date().getDate() + 1)),
//   ]);
//   const [roomsData, setRoomsData] = useState([]);
//   const [availableCalenderRoomsRes, setAvailableCalenderRoomsRes] = useState(
//     []
//   );

//   const host = "http://13.203.79.3:3000";

//   const roomBooking = (roomId) => {
//     const selectedRoom = roomsData.find((e) => e.room_id === roomId);
//     const isChecked = selectedRooms.some((room) => room.room_id === roomId);
//     setSelectedRooms((prevSelectedRooms) => {
//       const updatedRooms = isChecked
//         ? prevSelectedRooms.filter((room) => room.room_id !== roomId)
//         : [...prevSelectedRooms, selectedRoom];

//       const bookingDetailsData = {
//         locationId: document.getElementById("locationIds").value,
//         date: moment(startDate).format("YYYY-MM-DD"),
//         daysStay: document.getElementById("daysStay").value,
//         selectedRooms: updatedRooms,
//         selectedDateRange: nextDates,
//         fromDate: moment(nextDates[0]).format("YYYY-MM-DD"),
//         toDate: moment(nextDates[1]).format("YYYY-MM-DD"),
//       };

//       localStorage.setItem(
//         "bookingDetailsData",
//         JSON.stringify(bookingDetailsData)
//       );
//       return updatedRooms;
//     });
//   };

//   const handleCheckAvailability = async () => {
//     await checkAvailability();
//   };

//   const populateAvailableRoomsInCalendar = (dateParam) => {
//     let dateQueryParam = nextDates
//       .map((d) => moment(d).format("YYYY-MM-DD"))
//       .toString();

//     fetch(
//       `${host}/get-calendar-rooms?location=${document.getElementById("locationIds").value}&date=${dateQueryParam}&time=${Math.round(new Date().getTime() / 1000)}`
//     )
//       .then((response) => response.json())
//       .then((availableCalenderRoomsRes) =>
//         setAvailableCalenderRoomsRes(availableCalenderRoomsRes)
//       );
//   };

//   const checkAvailability = async () => {
//     const locationId = document.getElementById("locationIds").value;
//     fetch(
//       `${host}/get-rooms?location=${locationId}&time=${Math.round(new Date().getTime() / 1000)}`
//     )
//       .then((response) => response.json())
//       .then((roomsRes) => {
//         setRoomsData(roomsRes);
//         populateAvailableRoomsInCalendar();
//       });
//   };

//   useEffect(() => {
//     checkAvailability();
//   }, []);

//   //   const renderDayContents = (date) => {
//   //     let dateDay = moment(date).format("YYYY-MM-DD");
//   //     const availableCount = availableCalenderRoomsRes[dateDay] || 0;
//   //     const notAvailableCount = roomsData.length - availableCount;

//   //     return (
//   //       <div
//   //         style={{ display: "flex", flexDirection: "column", fontSize: "11px" }}
//   //       >
//   //         <div style={{ fontSize: "15px" }}>{date.getDate()}</div>
//   //         <div className="calendar_available" style={{ color: "green" }}>
//   //           {availableCount > 0 ? `${availableCount} Available` : ""}
//   //         </div>
//   //         <div className="calendar_booked" style={{ color: "red" }}>
//   //           {notAvailableCount > 0 ? `${notAvailableCount} Booked` : ""}
//   //         </div>
//   //       </div>
//   //     );
//   //   };

//   const renderDayContents = (date) => {
//     let dateDay = moment(date).format("YYYY-MM-DD");
//     const availableCount = availableCalenderRoomsRes[dateDay] || 0;
//     const notAvailableCount = roomsData.length - availableCount;

//     return (
//       <div
//         style={{ fontSize: "14px", color: availableCount ? "green" : "red" }}
//       >
//         <div>{date.getDate()}</div>
//         <div>
//           {availableCount > 0 ? `${availableCount} Available` : "Booked"}
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div>
//       <Header />
//       <div className="container">
//         <h1
//           className="text-center"
//           style={{ fontSize: "25px", color: "green" }}
//         >
//           Venues
//         </h1>
//         <div className="container-row">
//           <div style={{ width: "20%" }}>
//             <b>Select Location</b>
//             <select id="locationIds" onChange={checkAvailability}>
//               <option value="1">Gurajada Kalakshetram</option>
//               <option value="2">MGM LAN</option>
//               <option value="3">Chinnamusidivada</option>
//               <option value="4">Children's Arena</option>
//             </select>
//           </div>
//           <div style={{ width: "11%" }}>
//             <b>Days Stay</b>
//             <select
//               id="daysStay"
//               onChange={() =>
//                 setNextDates([
//                   new Date(),
//                   new Date(
//                     new Date().setDate(
//                       new Date().getDate() +
//                         parseInt(document.getElementById("daysStay").value - 1)
//                     )
//                   ),
//                 ])
//               }
//             >
//               {[...Array(10).keys()].map((d) => (
//                 <option key={d + 1} value={d + 1}>
//                   {d + 1}
//                 </option>
//               ))}
//             </select>
//           </div>
//           <div style={{ width: "37%" }}>
//             <b>Select Dates</b>
//             <div className="calendar-container">
//               {/* Custom two-month calendar structure */}
//               {[...Array(2).keys()].map((monthOffset) => {
//                 const monthDate = new Date();
//                 monthDate.setMonth(monthDate.getMonth() + monthOffset);
//                 return (
//                   <div key={monthOffset} className="calendar-month">
//                     <h3>{moment(monthDate).format("MMMM YYYY")}</h3>
//                     <div className="calendar-grid">
//                       {[...Array(31).keys()].map((day) => (
//                         <div
//                           key={day}
//                           className="calendar-day"
//                           onClick={() =>
//                             setStartDate(
//                               new Date(
//                                 monthDate.getFullYear(),
//                                 monthDate.getMonth(),
//                                 day + 1
//                               )
//                             )
//                           }
//                         >
//                           {renderDayContents(
//                             new Date(
//                               monthDate.getFullYear(),
//                               monthDate.getMonth(),
//                               day + 1
//                             )
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//           <div style={{ width: "20%" }}>
//             <button
//               id="check_availability_button"
//               className="btnclass"
//               onClick={checkAvailability}
//               style={{ width: "100%" }}
//             >
//               Check Availability
//             </button>
//           </div>
//         </div>
//         <div className="selected-rooms-list">
//           <h4>Selected Rooms:</h4>
//           <ul>
//             {selectedRooms.map((room) => (
//               <li key={room.room_id}>
//                 <strong>Room Name:</strong> {room.room_name},{" "}
//                 <strong>Price:</strong> Rs. {room.amount}/- per day
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Accomodation;
